// Not sure why previous env logic was removed - but hard-coded to prod for now
let clientId = "9e4f9f02-c907-4957-83e6-5f4f234ce93a";

// Development: 6e715b15-7287-4bfd-8de5-3b73017fd1f2
// Production: 9e4f9f02-c907-4957-83e6-5f4f234ce93a

const config = {
    instance: 'https://login.microsoftonline.com/',
    tenant: 'OceanaGold.onmicrosoft.com',
    clientId: clientId,
    postLogoutRedirectUri: window.location.origin,
    cacheLocation: 'localStorage', // enable this for IE, as sessionStorage does not work for localhost.
};

export const authContext = new window.AuthenticationContext(config);